import React, { useRef } from 'react';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { ContainerWithMaxWidth } from '@/core/components/ContainerWithMaxWidth';
import { AbstractRoute } from '@/core/lib/router/route';
import { useRouterContext } from '@/core/lib/router/router.context';
import { SliderNavigation } from '@/next/components/SliderNavigation';

export type CategoriesListProps = { title: string; categories: { img: string; name: string; url: AbstractRoute }[] };

export const CategoriesList: React.FC<CategoriesListProps> = ({ categories, title }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const { Link } = useRouterContext();

  return (
    <>
      <section>
        <ContainerWithMaxWidth className="mb-3 grid grid-cols-[1fr_auto] space-y-0 lg:mb-6">
          <h2 className="text-heading font-semibold">{title}</h2>
          <div className="mt-4 hidden justify-end gap-4 md:flex">
            <SliderNavigation buttonRef={prevRef} type={'prev'} />
            <SliderNavigation buttonRef={nextRef} type={'next'} />
          </div>
        </ContainerWithMaxWidth>
        <ContainerWithMaxWidth className="max-lg:!p-0">
          <div className="rekative hide no-scrollbar flex justify-between gap-4 overflow-auto pb-3 max-lg:px-4 lg:gap-9">
            <Swiper modules={[Navigation]} spaceBetween={20} className="univers-swiper" navigation={{ prevEl: prevRef.current, nextEl: nextRef.current }} slidesPerView={'auto'}>
              {categories.map(({ name, url, img }) => (
                <SwiperSlide key={name} className="!w-[134px] lg:!w-[178px]">
                  <Link key={name} href={url} className="group flex flex-col items-center justify-center gap-2 text-center">
                    <span className="flex size-[134px] items-center justify-center overflow-hidden rounded-full bg-[url(../../../public/assets/home/categories/background.png)] bg-cover lg:size-[178px]">
                      <img className="size-3/4 transition-all group-hover:size-[90%]" src={img} alt={name} />
                    </span>
                    <span>{name}</span>
                  </Link>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </ContainerWithMaxWidth>
      </section>
    </>
  );
};
